export default __webpack_public_path__ + "static/media/select_arrow.2f6cf91e.svg";